import React from 'react';
import styled from 'styled-components';
import { FacilityData } from './types'; // Import types
interface PivotTableProps {
  data: FacilityData;
  periodStartDates: string[];
}

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto; /* Enable horizontal scrolling */
  max-height: 500px;
  overflow-y: auto; /* Enable vertical scrolling */
`;

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  th,
  td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    white-space: nowrap; /* Prevent text wrapping */

    &.sticky_occupation {
      position: sticky;
      left: 150px; /* Should match the min-width of the first column */
      background-color: #fff;
      min-width: 150px;
      z-index: 3; /* Ensure it's above the data columns but below Facility */
    }

    &.sticky_facility {
      position: sticky;
      left: 0;
      background-color: #fff;
      min-width: 150px;
      z-index: 3; /* Ensure it's above other sticky columns */
      text-align: left;
    }
  }
  th {
    background-color: #f4f4f4;
    position: sticky;
    top: 0; /* Sticky header */
    z-index: 1; /* Keep header above table content */

    &.sticky_occupation {
      position: sticky;
      left: 150px; /* Should match the min-width of the first column */
      background-color: #fff;
      min-width: 150px;
      z-index: 3; /* Ensure it's above the data columns but below Facility */
    }

    &.sticky_facility {
      position: sticky;
      left: 0;
      background-color: #fff;
      min-width: 150px;
      z-index: 3; /* Ensure it's above other sticky columns */
    }
  }
`;

const UtilizationPivotTable: React.FC<PivotTableProps> = ({ data, periodStartDates }) => {
  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            <th className="sticky_facility">Facility</th>
            <th className="sticky_occupation">Occupation</th>
            {periodStartDates.map((date) => (
              <th key={date}>{date}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.entries(data).map(([facility, occupations]) => {
            const occupationKeys = Object.keys(occupations);
            return occupationKeys.map((occupation, i) => (
              <tr key={`${facility}-${occupation}`}>
                {i === 0 && (
                  <td rowSpan={occupationKeys.length} className="sticky_facility">
                    {facility}
                  </td> /* Facility spans across multiple occupations */
                )}
                <td className="sticky_occupation">{occupation}</td>
                {periodStartDates.map((date) => (
                  <td key={`${occupation}-${date}`}>
                    {occupations[occupation][date] !== undefined ? occupations[occupation][date] : 0}
                  </td>
                ))}
              </tr>
            ));
          })}
        </tbody>
      </Table>
    </TableWrapper>
  );
};

export default UtilizationPivotTable;
